import { useUser } from '#/contexts/UserEnvironmentContext';

export function useUserPostAListingHref() {
  const { user } = useUser();

  const postableOrgs =
    user?.orgs.filter((org) => org.canTakeAdminActions) ?? [];

  if (user && user.orgs.length > 0 && postableOrgs.length === 0) {
    return `/admin/${user.orgs[0].id}`;
  }

  if (postableOrgs.length === 1) {
    const [org] = postableOrgs;
    if (org.isAllowedToPost && !org.isFrozen) {
      return `/admin/${org.id}/post-a-listing`;
    }

    return `/admin/${org.id}`;
  }

  return '/post-a-listing';
}
